import { DEFAULT_SYS_PROMPT, useGlobal } from "@/app/providers/use-global";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { useState } from "react";

type SystemPromptDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export const SystemPromptDialog = ({
  open,
  onOpenChange,
}: SystemPromptDialogProps) => {
  const { systemPrompt, setSystemPrompt } = useGlobal();
  const [systemPromptInput, setSystemPromptInput] = useState<string>(
    systemPrompt === DEFAULT_SYS_PROMPT ? "" : systemPrompt,
  );

  const handleResetSystemPrompt = () => {
    setSystemPrompt(DEFAULT_SYS_PROMPT);
    setSystemPromptInput("");
    onOpenChange(false);
  };

  const handleSaveSystemPrompt = () => {
    setSystemPrompt(systemPromptInput);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <button
          className="w-full flex text-sm items-center px-2 py-1.5 hover:bg-accent dark:hover:bg-neutral-700"
          type="button"
        >
          <div className="w-4 h-4 mr-2" />
          System Prompt
        </button>
      </DialogTrigger>
      <DialogContent className="w-full h-full md:max-w-[455px] md:h-auto">
        <div>
          <h3 className="mt-5">System Prompt</h3>
          <textarea
            className="w-full h-[231px] mt-6 mb-5 rounded-lg caret-mutedaccent placeholder-mutedaccent resize-none focus:outline-none border-mutedaccent focus:border-mutedaccent focus:ring-0 bg-inherit dark:bg-[#202125] dark:text-white"
            value={systemPromptInput}
            onChange={(e) => setSystemPromptInput(e.target.value)}
            placeholder={DEFAULT_SYS_PROMPT}
          />
          <div className="flex items-center">
            <Button
              className="ml-auto dark:text-[#9DA4B2]"
              variant="outline"
              onClick={handleResetSystemPrompt}
            >
              Reset
            </Button>
            <Button
              className="ml-3 text-background bg-foreground dark:text-black dark:bg-white"
              onClick={handleSaveSystemPrompt}
            >
              Save
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
